import React from 'react';
import { CampaignMappingView } from 'src/features/CampaignMapping';
import { CampaignMappingsDataContextProvider } from 'src/features/CampaignMapping';
import { DesktopOnlyGuard } from 'src/components/molecules/DesktopOnlyGuard';

export const CampaignMapping: React.FC = () => {
  return (
    <DesktopOnlyGuard>
      <CampaignMappingsDataContextProvider>
        <CampaignMappingView />
      </CampaignMappingsDataContextProvider>
    </DesktopOnlyGuard>
  );
};
